export default [
    {path: '/bindUser', component: () => import('@/views/BindUser.vue'), notLogin: true},

]